import swal from "sweetalert";

export const alert = (title, data, type) => {
  return swal(title, data, type);
};

export const warning = () => {
  return swal({
    title: "Are You Sure!",
    icon: "warning",
    dangerMode: true,
    buttons: ["Cancel", "Delete"],
  });
};

export const logoutWarning = () => {
  return swal({
    title: "Are You Sure!",
    // text: "Do you want to logout?",
    icon: "warning",
    dangerMode: true,
    buttons: ["Cancel", "Logout"], 
  });
};
